import type { TranslationModule } from '../types';

export const practicaNeunitaraTranslations: TranslationModule = {
  ro: {
    seoTitle: "Practică neunitară — repertoriu consolidat de soluții și probleme de drept | Legea Aplicată",
    seoDesc: "Caută și explorează repertoriul consolidat de practică neunitară din România. Probleme de drept cu soluții divergente, opinii INM și decizii ale instanțelor pe materii.",
    eyebrow: "Repertoriu juridic consolidat",
    title: "Practică neunitară",
    description: "Găsește rapid probleme de drept cu soluții divergente, opinii INM și soluții însușite de participanți în toate materiile juridice.",
    searchPlaceholder: "Ex.: prescripția răspunderii penale, clauze abuzive, competență...",
    searchButton: "Caută",
    searchAriaLabel: "Caută în practica neunitară",
    browseEyebrow: "Răsfoire",
    browseHeading: "Materii juridice",
    allMattersCount: "{count} probleme",
    filtersToggle: "Filtre",
    filtersHeading: "Organizare",
    closeFilters: "Închide filtrele",
    activeFiltersLabel: "Filtre active",
    filterMatter: "Materie",
    allMatters: "Toate materiile",
    filterPath: "Cale",
    allPaths: "Toate căile",
    filterSubpath: "Subcale",
    allSubpaths: "Toate subcăile",
    filterLocality: "Localitatea întâlnirii",
    allLocalities: "Toate localitățile",
    filterNote: "Notă",
    allNotes: "Toate",
    withNote: "Cu notă",
    withoutNote: "Fără notă",
    resetFilters: "Resetează filtrele",
    searching: "Se caută…",
    resultsCount: "{count} rezultate",
    resultsFor: "Rezultate pentru „{query}”",
    catalogOrder: "Probleme în ordinea repertoriului",
    sortLabel: "Sortează rezultatele",
    sortRelevance: "Relevanță",
    sortCatalog: "Ordine repertoriu",
    sortAsc: "Ordine crescătoare",
    sortDesc: "Ordine descrescătoare",
    loadErrorTitle: "Nu am putut încărca repertoriul.",
    loadingResults: "Se încarcă rezultatele…",
    noResultsTitle: "Niciun rezultat găsit",
    noResultsDesc: "Încearcă o formulare mai scurtă sau resetează filtrele.",
    paginationPrev: "Anterior",
    paginationNext: "Următor",
    paginationPage: "Pagina {page} din {total}",
    cardNote: "Notă",
    cardPage: "pag. {start}",
    cardPageRange: "pag. {start}–{end}",
    cardDetails: "Vezi detalii",
    researchGuide: "Repere pentru cercetare",
    officialSourceLink: "Verifică sursa oficială — Institutul Național al Magistraturii (INM)",
    detailBack: "Înapoi la repertoriu",
    detailLoadError: "Problema nu a putut fi încărcată.",
    detailOrder: "Ordinea {order}",
    detailNumber: "Nr. {num}",
    detailHierarchy: "Ierarhia completă",
    detailLawProblem: "Problema de drept",
    detailSource: "Sursa",
    detailNotSpecified: "Nu este precizată în repertoriu.",
    detailSourcePages: "Pagini-sursă",
    detailMeeting: "Întâlnirea",
    detailNoMeetingDesc: "Fără descriere.",
    detailInmOpinion: "Opinia Institutului Național al Magistraturii și argumentele",
    detailParticipantsSolution: "Soluția însușită de participanți",
    detailSummary: "Rezumatul soluției însușite și argumentele",
    detailNote: "Notă",
    detailFullContent: "Conținut integral",
    detailExpand: "(extinde secțiunea)",
  },
  en: {
    seoTitle: "Divergent case law — consolidated repository of legal issues and solutions | Legea Aplicată",
    seoDesc: "Search and explore the consolidated Romanian divergent judicial practice repository. Conflicting legal issues, INM opinions, and court resolutions by legal matter.",
    eyebrow: "Consolidated legal directory",
    title: "Divergent Case Law",
    description: "Quickly find legal issues with conflicting judicial solutions, National Institute of Magistracy (INM) opinions, and conclusions adopted by judges across all legal fields.",
    searchPlaceholder: "E.g.: statute of limitations, unfair contract terms, jurisdiction...",
    searchButton: "Search",
    searchAriaLabel: "Search in divergent case law repository",
    browseEyebrow: "Browse",
    browseHeading: "Legal domains",
    allMattersCount: "{count} issues",
    filtersToggle: "Filters",
    filtersHeading: "Organization",
    closeFilters: "Close filters",
    activeFiltersLabel: "Active filters",
    filterMatter: "Legal domain",
    allMatters: "All domains",
    filterPath: "Path",
    allPaths: "All paths",
    filterSubpath: "Subpath",
    allSubpaths: "All subpaths",
    filterLocality: "Meeting location",
    allLocalities: "All locations",
    filterNote: "Note",
    allNotes: "All",
    withNote: "With note",
    withoutNote: "Without note",
    resetFilters: "Reset filters",
    searching: "Searching…",
    resultsCount: "{count} results",
    resultsFor: "Results for “{query}”",
    catalogOrder: "Issues in directory order",
    sortLabel: "Sort results",
    sortRelevance: "Relevance",
    sortCatalog: "Directory order",
    sortAsc: "Ascending order",
    sortDesc: "Descending order",
    loadErrorTitle: "Could not load the directory.",
    loadingResults: "Loading results…",
    noResultsTitle: "No results found",
    noResultsDesc: "Try a shorter search term or reset the filters.",
    paginationPrev: "Previous",
    paginationNext: "Next",
    paginationPage: "Page {page} of {total}",
    cardNote: "Note",
    cardPage: "p. {start}",
    cardPageRange: "pp. {start}–{end}",
    cardDetails: "View details",
    researchGuide: "Research guidelines",
    officialSourceLink: "Official source — National Institute of Magistracy (INM)",
    detailBack: "Back to repository",
    detailLoadError: "The issue could not be loaded.",
    detailOrder: "Order {order}",
    detailNumber: "No. {num}",
    detailHierarchy: "Full hierarchy",
    detailLawProblem: "Legal issue",
    detailSource: "Source",
    detailNotSpecified: "Not specified in the repository.",
    detailSourcePages: "Source pages",
    detailMeeting: "Judicial meeting",
    detailNoMeetingDesc: "No description available.",
    detailInmOpinion: "INM opinion and legal arguments",
    detailParticipantsSolution: "Solution adopted by participants",
    detailSummary: "Summary of adopted solution and arguments",
    detailNote: "Note",
    detailFullContent: "Full text",
    detailExpand: "(expand section)",
  },
  fr: {
    seoTitle: "Pratique non unitaire — répertoire consolidé de questions de droit et solutions | Legea Aplicată",
    seoDesc: "Recherchez et explorez le répertoire consolidé de jurisprudence non unitaire en Roumanie. Questions de droit divergentes, avis de l'INM et résolutions judiciaires.",
    eyebrow: "Répertoire juridique consolidé",
    title: "Pratique non unitaire",
    description: "Trouvez rapidement les questions de droit aux solutions divergentes, les avis de l'INM et les solutions adoptées par les magistrats dans toutes les matières juridiques.",
    searchPlaceholder: "Ex. : prescription de la responsabilité pénale, clauses abusives, compétence...",
    searchButton: "Rechercher",
    searchAriaLabel: "Rechercher dans la pratique non unitaire",
    browseEyebrow: "Parcourir",
    browseHeading: "Matières juridiques",
    allMattersCount: "{count} questions",
    filtersToggle: "Filtres",
    filtersHeading: "Organisation",
    closeFilters: "Fermer les filtres",
    activeFiltersLabel: "Filtres actifs",
    filterMatter: "Matière",
    allMatters: "Toutes les matières",
    filterPath: "Voie",
    allPaths: "Toutes les voies",
    filterSubpath: "Sous-voie",
    allSubpaths: "Toutes les sous-voies",
    filterLocality: "Lieu de la réunion",
    allLocalities: "Tous les lieux",
    filterNote: "Note",
    allNotes: "Toutes",
    withNote: "Avec note",
    withoutNote: "Sans note",
    resetFilters: "Réinitialiser les filtres",
    searching: "Recherche en cours…",
    resultsCount: "{count} résultats",
    resultsFor: "Résultats pour « {query} »",
    catalogOrder: "Questions dans l'ordre du répertoire",
    sortLabel: "Trier les résultats",
    sortRelevance: "Pertinence",
    sortCatalog: "Ordre du répertoire",
    sortAsc: "Ordre croissant",
    sortDesc: "Ordre décroissant",
    loadErrorTitle: "Impossible de charger le répertoire.",
    loadingResults: "Chargement des résultats…",
    noResultsTitle: "Aucun résultat trouvé",
    noResultsDesc: "Essayez une formulation plus courte ou réinitialisez les filtres.",
    paginationPrev: "Précédent",
    paginationNext: "Suivant",
    paginationPage: "Page {page} sur {total}",
    cardNote: "Note",
    cardPage: "p. {start}",
    cardPageRange: "pp. {start}–{end}",
    cardDetails: "Voir les détails",
    researchGuide: "Repères de recherche",
    officialSourceLink: "Vérifier la source officielle — Institut National de la Magistrature (INM)",
    detailBack: "Retour au répertoire",
    detailLoadError: "La question n'a pas pu être chargée.",
    detailOrder: "Ordre {order}",
    detailNumber: "N° {num}",
    detailHierarchy: "Hiérarchie complète",
    detailLawProblem: "Question de droit",
    detailSource: "Source",
    detailNotSpecified: "Non précisé dans le répertoire.",
    detailSourcePages: "Pages sources",
    detailMeeting: "Réunion des magistrats",
    detailNoMeetingDesc: "Aucune description fournie.",
    detailInmOpinion: "Avis de l'Institut National de la Magistrature et arguments",
    detailParticipantsSolution: "Solution retenue par les participants",
    detailSummary: "Résumé de la solution retenue et arguments",
    detailNote: "Note",
    detailFullContent: "Contenu intégral",
    detailExpand: "(développer la section)",
  },
};
